import Component from 'vue-class-component';
import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Alternatives/Attributes/Domain/queries';

@Component
export default class AttributesQueries extends VueCqrs
{
	runAttributeByIdQueryV1(workspaceId: number, projectId: number, alternativesListId: number, attributeId: number)
	{
		const query = q.buildAttributeByIdQueryV1(workspaceId, projectId, alternativesListId, attributeId);
		this.$query(query);
	}

	runAttributesListByProjectIdQueryV1(workspaceId: number, projectId: number, includeSystemAttributes: boolean)
	{
		const query = q.buildAttributesListByProjectIdQueryV1(workspaceId, projectId, includeSystemAttributes);
		this.$query(query);
	}

	runAttributeDependenciesQueryV1(workspaceId: number, projectId: number, alternativesListId: number, attributeId: number)
	{
		const query = q.buildAttributeDependenciesQueryV1(workspaceId, projectId, alternativesListId, attributeId);
		this.$query(query);
	}

	runAttributeEditorQueryV1(workspaceId: number, projectId: number, attributeId: number | null)
	{
		const query = q.buildAttributeEditorQueryV1(workspaceId, projectId, attributeId);
		this.$query(query);
	}

	runCalcAttributeScriptTestQueryV1(workspaceId: number, projectId: number, alternativesListId: number, script: string, inputs: { Name: string, Value: number }[])
	{
		const query = q.buildCalcAttributeScriptTestQueryV1(workspaceId, projectId, alternativesListId, script, inputs);
		this.$query(query);
	}

	runEmailAttributeDefinedValuesByPeopleTagQueryV1(workspaceId: number, projectId: number, peopleTag: string)
	{
		const query = q.buildEmailAttributeDefinedValuesByPeopleTagQueryV1(workspaceId, projectId, peopleTag);
		this.$query(query);
	}
}